import { useContext } from "react";
import { RemovalItemCostsStateContext } from "../SimulationProvider";

export const useRemovalItemCostsState = () => {
  const state = useContext(RemovalItemCostsStateContext);
  return state;
};
